import { LoadingButton } from '@mui/lab';
import { Box, Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import GeneralDriverTextFiled from 'src/components/general/GeneralDriverTextFiled';
import { FormProvider } from 'src/components/hook-form';
import useFormsModalStore from 'src/store/forms';
import { getDefaultValues } from './defaultValues';
import { networkGetProjectDomainInsert, networkGetProjectDomainUpdate } from 'src/network/application';
import useProjectInfoStore from 'src/store/project';
import { APP_VERSION_CONTROL_LIST } from 'src/constants/queryKeys';
import { yupResolver } from '@hookform/resolvers/yup';
import { schema } from './validationSchema';

const DomianForm = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const { projectInfo } = useProjectInfoStore();
  const projectId = projectInfo?.ApplicationID;

  const { modal, closeModal } = useFormsModalStore();

  const { id, isEditMode, value } = modal?.data;

  const landingDetails = modal?.data;
  const defaultValues = getDefaultValues(landingDetails);

  const methods = useForm({
    resolver: yupResolver(schema), // todo schema
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (values, event) => {
    const payload = {
      ...values,
      ApplicationDomainApplicationID: +projectId,
      ApplicationDomainAliasApplicationID: +projectId,
    };

    try {
      if (isEditMode) {
        const res = await networkGetProjectDomainUpdate(id, payload);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('آیتم موردنظر با موفقیت ویرایش شد');
          closeModal();
          reset();
          await queryClient.invalidateQueries(['project-domain']);
        } else {
          enqueueSnackbar('با مشکل مواجه شد !', { variant: 'error' });
        }
      } else {
        const res = await networkGetProjectDomainInsert(payload);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('آیتم موردنظر با موفقیت ایجاد شد');
          closeModal();
          reset();
          await queryClient.invalidateQueries(['project-domain']);
        } else {
          enqueueSnackbar('با مشکل مواجه شد !', { variant: 'error' });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box
        sx={{
          display: 'grid',
          columnGap: 2,
          rowGap: 3,
          gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
          mt: 2,
        }}
      >
        <GeneralDriverTextFiled
          helperDesc={
            <div className="flex flex-col gap-1">
              <p>ادرس سایت</p>
            </div>
          }
          name="ApplicationDomainHostName"
          type="text"
          label="دامنه"
        />
      </Box>

      <div className="flex items-center gap-4 mt-6">
        <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
          ذخیره
        </LoadingButton>
        <Button onClick={closeModal} variant="contained" color="error">
          انصراف
        </Button>
      </div>
    </FormProvider>
  );
};

export default DomianForm;
